import { useNavigate } from 'react-router-dom'
import { apiURL } from '../utilities/URLs'
import { account } from '../classes/Account'
import { endTrackedSession } from '../utilities/tracking/endSession'
import { trackAction } from '../utilities/tracking/trackAction'

export default function Account({ setShowNavBar }) {
  const navigate = useNavigate()

  const handleLogout = async () => {
    trackAction('logout')
    await endTrackedSession({ accountId: account.accountId })
    const clearCookieResponse = await fetch(`${apiURL}/api/access-token/clear-cookie`, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        sessionId: localStorage.getItem('portalSessionId'),
        accountId: account.accountId
      })
    })
    const clearCookieData = await clearCookieResponse.json()
    if(clearCookieData.response.error)
      console.error(clearCookieData.response.error)
    else {
      localStorage.removeItem('portalAccessToken')
      setShowNavBar(false)
      navigate('/')
    }
  }

  return (
    <div className='w-screen flex flex-col items-center p-6'>
      <p className='font-bold text-2xl text-center mb-6'>My Account</p>
      <button onClick={handleLogout} className='mt-4 bg-ertc-primary text-white px-4 py-2 rounded'>Logout</button>
    </div>
  )
}